export default __webpack_public_path__ + "static/media/3-4.7de4eb4e.png";